module.exports = __webpack_public_path__ + "images/editFooterVector.dafdc74f.svg";